import React, {useState} from 'react';
import {useForm} from "react-hook-form";
import {ApiError, ApiService} from "../../service/ApiService";
import {useAppDispatch} from "../../redux/store";
import {me as findMe} from "../../redux/auth_reducer";
import {AuthService} from "../../service/AuthService";

type FormDataType = {
  password: string,
  repassword: string,
}

export const PasswordChangeForm = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const {register, handleSubmit, setError, formState: {errors}} = useForm<FormDataType>();

  const onSubmit = async (data: FormDataType) => {
    if (data.password !== data.repassword) {
      setError('repassword', {
        type: 'manual',
        message: 'Mot de passe et Confirmer doivent être identique.'
      });

      return;
    }

    try {
      setLoading(true);
      await ApiService.post('/me/password', {param: () => ({password: data.password})});
      dispatch(findMe());
    } catch (e: any) {
      const error: ApiError = e as ApiError;
      setError('password', {type: 'manual', message: error.errors?.[0]?.message ?? e.message});
      setLoading(false);
    }
  }

  return (
    <form className="p-3" method="post" onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-5 text-center bold">
        Votre mot de passe est provisoire, <br/>
        vous devez en choisir un nouveau.
      </div>

      <div className="input-group mb-3">
        <span className="input-group-text"><i className="fa-solid fa-key"></i></span>
        <input type="password" autoComplete="new-password" className="form-control" placeholder="Nouveau mot de passe" {...register('password', {
          required: 'Mot de passe est requis',
          minLength: {value: 8, message: 'Le mot de passe doit contenir au moins 8 caractères.'},
        })} />
      </div>

      <div className="input-group mb-3">
        <span className="input-group-text"><i className="fa-solid fa-key"></i></span>
        <input type="password" autoComplete="new-password" className="form-control" placeholder="Confirmer" {...register('repassword', {
          required: 'Confirmer est requis',
        })} />
      </div>

      {errors.password && <div className="bold text-center text-danger">{errors.password.message}</div>}
      {errors.repassword && <div className="bold text-center text-danger">{errors.repassword.message}</div>}

      <div className="__form-login_button__">
        <button className="btn btn-success mt-3 bold" disabled={loading}>
          Enregistrer
          {loading && (
            <span className="ms-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          )}
        </button>
        <button type="button" className="btn btn-warning btn-sm mt-2 text-light" onClick={() => AuthService.logout()}>Déconnexion</button>
      </div>
    </form>
  );
}
